<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" class="pb-0">
        <layers-navigation-tabs :selectedTab.sync="selectedTabNavegationTabs" />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="pt-0">
        <layers-data-table
          ref="layersDataTable"
          :titulo="tituloTabela"
          :items="items"
          :loading="loading"
          @rechargeTable="chargeTableDecision(tipoListaRelatorio)"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import RelatoriosService from '@/services/RelatoriosService';
  import refreshDataMixins from '@/mixins/refreshDataMixins';

  export default {
    components: {
      LayersNavigationTabs: () => import('@/components/layers-personalizados/LayersNavigationTabs'),
      LayersDataTable: () => import('@/components/layers-personalizados/LayersDataTable')
    },
    mixins: [refreshDataMixins],

    data: () => ({
      items: [],
      tituloTabela: 'Layers',
      selectedTabNavegationTabs: 0,
      loading: false
    }),

    computed: {
      tipoListaRelatorio() {
        return this.$store.getters.getTipoListaLayer;
      }
    },

    created() {
      this.chargeTableDecision(this.tipoListaRelatorio);
    },

    methods: {
      getRelatorios() {
        this.items = [];
        this.loading = true;
        RelatoriosService.index(1)
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      getRelatoriosFavoritados() {
        this.items = [];
        this.loading = true;
        RelatoriosService.getRelatoriosFavoritados(1)
          .then((response) => {
            this.items = response.data.data;
          })
          .finally(() => (this.loading = false));
      },

      chargeTableDecision(newDecisionInfo) {
        if (this.$refs.layersDataTable) {
          this.$refs.layersDataTable.page = 1;
        }
        this.tituloTabela = newDecisionInfo.titulo;

        switch (newDecisionInfo.tipo) {
          case 'favoritos':
            this.selectedTabNavegationTabs = 1;
            this.cancelRefreshData();
            this.refreshData(this.getRelatoriosFavoritados);
            break;
          case 'historico':
          default:
            this.selectedTabNavegationTabs = 0;
            this.cancelRefreshData();
            this.refreshData(this.getRelatorios);
            break;
        }
      }
    },

    watch: {
      tipoListaRelatorio(newValue) {
        this.chargeTableDecision(newValue);
      }
    }
  };
</script>
